import { api } from "@/APIRequests";
import type { Assessment } from "@/core/types";

type GetAssessmentDefinitionprops = {
  id: string;
};

export async function getDefinition({ id }: GetAssessmentDefinitionprops): Promise<Assessment> {
  return api.assessmentTyped.get_definition({
    assessmentId: id,
    params: { showLoader: false },
  });
}
